import { clsx } from "clsx";
import { useEffect, useState } from "react";
import { queryClient } from "../../app";
import { Chat, Lobby } from "../../entities";
import { SupportChatButton } from "../SupportChatButton";
import { SupportChatWindow } from "./SupportChatWindow";

export function SupportChatGuard({ className }: { className?: string }) {
  const { data: lobbyData } = Lobby.useLobby();

  const isConversationActive = lobbyData?.isIMActive ?? false;

  return isConversationActive && <SupportChat className={className} />;
}

function SupportChat({ className }: { className?: string }) {
  const [isMinimized, setIsMinimized] = useState(true);

  const conversations = Chat.useConversationList();
  const conversation = conversations.data?.result?.[0] ?? null;

  const isRead = conversation?.isRead ?? true;

  function onChatWindowClose() {
    queryClient.invalidateQueries({ queryKey: ["Conversation.getList"] });
    setIsMinimized(true);
  }

  function onChatWindowOpen() {
    const isMessagesFetching =
      queryClient.isFetching({ queryKey: ["Conversation.getMessages"] }) > 0;
    if (!isMessagesFetching) {
      queryClient.invalidateQueries({
        queryKey: ["Conversation.getMessages"],
      });
    }
    setIsMinimized(false);
  }

  useEffect(() => {
    if (isMinimized && !isRead) {
      queryClient.invalidateQueries({ queryKey: ["Conversation.getMessages"] });
    }
  }, [isMinimized, isRead]);

  return (
    <div className={clsx("support-chat-container", { "-open": !isMinimized }, className)}>
      <SupportChatButton onClick={onChatWindowOpen} />
      {!isMinimized && <SupportChatWindow onMinimized={onChatWindowClose} />}
    </div>
  );
}
